import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import Switch from '@/components/Switch';
import { handleSendMessageCrisp } from '@/helpers';
import { generalSettingSelector, handleSaveSettings } from '@/redux/slice/setting.slice';
import { BlockStack, Box, Card, InlineStack, Link } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

export const OrderTag = () => {
  const { t } = useTranslation('general_settings');
  const generalSettings = useSelector(generalSettingSelector);
  const dispatch = useDispatch();
  return (
    <Card padding={'300'}>
      <BlockStack gap={'300'}>
        <Box>
          <BoldText>{t('sections.orderManagement.orderTag.title')}</BoldText>
          <RegularText tone="subdued">{t('sections.orderManagement.orderTag.helpText')}</RegularText>
        </Box>
        <Card padding={'300'}>
          <InlineStack align="space-between">
            <BoldText as="h3" fontWeight="medium">
              {t('sections.orderManagement.orderTag.automaticSwitchTitle')}
            </BoldText>
            <Switch
              isActive={generalSettings.isEnableOrderTag}
              onSwitch={() => dispatch(handleSaveSettings({ isEnableOrderTag: !generalSettings.isEnableOrderTag }))}
            />
          </InlineStack>
          <RegularText>
            Orders are tagged with the relevant <RegularText fontWeight="bold">delivery method, date, time, day</RegularText> and{' '}
            <RegularText fontWeight="bold">location.</RegularText>
          </RegularText>
        </Card>
        <Box color="text-emphasis">
          {t('sections.orderManagement.orderTag.instruction')}{' '}
          <Link onClick={() => handleSendMessageCrisp(t('sections.orderManagement.orderTag.message'))}>Contact us</Link>
        </Box>
      </BlockStack>
    </Card>
  );
};
